<script>
import axios from "axios";
import { debounce } from "lodash";

export default {
  components: {},
  name: "uni-faculties",
  props: {
    universityId: {
      type: String | Number,
      required: true,
    },
 
  },
  data() {
    return {
      q: this.getQueryParam("q") || "",
      isLoadingList: false,
    };
  },
  methods: {
    getList: debounce(function () {
      this.isLoadingList = true;

      const params = new URLSearchParams();
      params.set("q", this.q);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      history.pushState(null, "", newUrl);

      axios
        .get('', {
          params: {
            title: this.q,
          },
        })
        .then((response) => {
          document.getElementById("list").innerHTML = response.data;
          this.isLoadingList = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoadingList = false;
        });
    }, 500),
    getQueryParam(paramName) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(paramName);
    },
  },
  watch: {
    q() {
      this.showFilters = false;
      this.getList();
    },
  },
};
</script>
